var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navBar"},[_c('MdNavBar',{staticClass:"MD"}),_c('PcNavBar',{staticClass:"PC"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }